<template>
  <div id="ecommerce">
    <div v-if="isSelectedBot">
      <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
        <v-tab href="#products" ripple>{{ $t('Products') }}</v-tab>
        <v-tab href="#ecommerce-order-summary" ripple>{{ $t('Order Summary') }}</v-tab>
        <v-tab
          ripple
          href="#aston-ads"
          v-if="$store.state.astonpages.includes(selectedBot.pageid)"
          >{{ $t('Aston') }}</v-tab
        >
        <v-tab href="#wholesale" ripple>{{ $t('All Wholesale') }}</v-tab>
        <v-tab href="#payment" ripple>{{ $t('Payments') }}</v-tab>
      </v-tabs>
      <div v-if="currentView == 'products'">
        <component :is="'products'"></component>
      </div>
      <div v-else-if="currentView == 'ecommerce-order-summary'">
        <component :is="'ecommerce-order-summary'"></component>
      </div>
      <div v-else-if="currentView == 'aston-ads'">
        <aston-ads></aston-ads>
      </div>
      <div v-else-if="currentView == 'wholesale'">
        <wholesale></wholesale>
      </div>
      <div v-else-if="currentView == 'payment'">
        <payment></payment>
      </div>
    </div>
    <div v-else>
      <template-empty></template-empty>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Products from './Products'
import Payment from './Payment'
import EcommerceOrderSummary from './ecommerce-order-summary'
import TemplateEmpty from '@/components/view/template/template-empty'
import Wholesale from './Wholesale'
import AstonAds from './AstonAds'

export default {
  data: function() {
    return {
      currentView: 'products'
    }
  },
  components: {
    TemplateEmpty,
    Products,
    EcommerceOrderSummary,
    Payment,
    Wholesale,
    AstonAds
  },
  created() {
    let vm = this
    if (vm.$route.query.tab) {
      switch (vm.$route.query.tab) {
        case 'products':
        case 'ecommerce-category':
        case 'ecommerce-order-summary':
          vm.currentView = vm.$route.query.tab
          break
        default:
          vm.currentView = 'products'
          break
      }
    } else {
      vm.currentView = 'products'
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),

    isSelectedBot: function() {
      return this.$store.state.isSelectedBot
    }
  },
  methods: {
    updateRoute: function() {
      this.$router.push({
        name: 'template',
        path: '/template',
        query: {
          tab: this.currentView
        }
      })
      this.routeValue = JSON.stringify(this.$route.query)
    }
  },
  watch: {
    currentView: function() {
      this.updateRoute()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ecommerce.vue